<template>
    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover"
        :class="{
            'mm-navigation__secondary-menu--active': open
        }">

        <router-link
            :to="to"
            class="mm-navigation__menu-link nav-link"
            :class="{
                'd-none d-lg-flex': mobileOnHover
            }"
            active-class="mm-navigation__menu-link--active">
            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
            <span class="mm-navigation__menu-list-item-label">
                {{label}}
            </span>
        </router-link>

        <router-link
            v-if="mobileOnHover"
            :to="to"
            @click.native="open = !open"
            class="mm-navigation__menu-link nav-link"
            :class="{
                'd-flex d-lg-none': mobileOnHover
            }"
            active-class="mm-navigation__menu-link--active"
            :event="''"
             @click.native.prevent="toggle">
            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
            <span class="mm-navigation__menu-list-item-label">
                {{label}}
            </span>
        </router-link>

        <div class="mm-navigation__secondary-menu-wrapper">
            <div class="mm-navigation__secondary-menu">
                <div class="mm-navigation__secondary-menu-content">
                    <div class="mm-navigation__secondary-menu-info">
                        <div class="headline--fifth headline--colored headline--uppercase">
                            {{submenuContentHeading}}
                        </div>
                        <div class="text--smaller-paragraph text--bold-paragraph">
                            {{submenuContentDescription}}
                        </div>
                    </div>
                    <div class="mm-navigation__secondary-menu-items">
                        <router-link
                            :to="localeRoute(item.routeName)"
                            class="mm-navigation__secondary-menu-item"
                            :key="item.id"
                            v-for="item in items">
                            <div class="mm-navigation__secondary-menu-icon"><i class="icon icon-home"></i></div>
                            <div class="mm-navigation__secondary-menu-item-info">
                                <div class="mm-navigation__secondary-menu-item-name headline--colored headline--uppercase">
                                    {{item.name}}
                                </div>
                                <div class="mm-navigation__secondary-menu-item-desc text--smaller-paragraph">
                                    {{item.description}}
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

    </li>
</template>

<script>
export default {
    props: {
        to: {
            type: Object
        },
        label: {
            type: String
        },
        submenuContentHeading: {
            type: String
        },
        submenuContentDescription: {
            type: String
        },
        items: {
            type: Array
        },
        mobileOnHover: {
            type: Boolean
        }
    },
    data() {
        return {
            open: false
        };
    },
    methods: {
        toggle() {
            this.open = !!this.open;
        }
    }
}
</script>